// https://material-ui.com/demos/expansion-panels/#controlled-accordion
import { FAQPageJsonLd } from 'next-seo';
import React from 'react';
import FaqItem from './FaqItem';

const FAQAccordion = () => {
  const faqs = [
    {
      questionName: 'How can I get curated?',
      acceptedAnswerText:
        'Every day, we read all posts submitted to TravelFeed that meet our quality requirements. You can submit posts by posting through TravelFeed (recommended) or by posting through other Hive frontends using the code snippet generated using our map picker.',
    },
    {
      questionName: 'What does it mean to get curated?',
      acceptedAnswerText:
        'The top 5 posts of the day receive a full upvote (10 smile) from TravelFeed. You will also receive Hive upvotes from curators who follow our curation trail. This usually means substantial rewards. Our daily top picks are also featured on the front page of TravelFeed and reblogged on Hive, resulting in more exposure.',
    },
    {
      questionName: 'What are the quality requirements for posts?',
      acceptedAnswerText: `<p>We consider all posts for curation that meet our quality requirements:</p>
        <ul>
        <li>Only original content;</li>
        <li>Your post must be in the language selected. We're currently curating in English, Polish, Spanish and German;</li>
        <li>At least 250 words (in the language selected);</li>
        <li>Only use media and texts that are your own or that you have permission to use (e.g. CC0 license, public domain);</li>
        <li>If you are using any texts that are not your own (e.g. Wikipedia excerpts) you are required to mark them by putting them in a quote;</li>
        <li>We require to put an attribution for any media or texts that are not your own;</li>
        <li>Only travel-related content;</li>
        <li>Your post must not be a repost of your previous TravelFeed posts.</li>
        </ul>
        <p>If you don't comply with our requirements, we reserve the right to remove your post from our platform or decrease its visibility. We are legally required to remove copyright infringements.</p>
        <p>If you want to publish your posts to Hive, please revise your cross-posting settings via your dashboard. Respect the rules of the communities you post to.</p>
        </ul>`,
    },
    {
      questionName: 'What are smiles?',
      acceptedAnswerText:
        'On TravelFeed, you can upvote posts and comments by pressing the vote button and moving it to the desired voting power. We call that giving smiles. You can give up to 10 smiles per post, equaling a 100% upvote on Hive. The more smiles you give, the less powerful they are, but your fuel tank recharges by 100 smiles every day. The more smiles are given to a post, the more visibility it will get and the higher the reward that the author will get from the rewards pool. The rewards for a post are not only determined by the total amount of smiles received, but also by the influence (currently determined by Hive Power held) of each curator — one smile by a powerful account like @travelfeed can be worth more than ten smiles from a small account.',
    },
    {
      questionName: 'What is a curator?',
      acceptedAnswerText:
        'A curator is anyone voting on TravelFeed posts, including yourself. By giving smiles to a post before it goes viral, you can earn curation rewards from the rewards pool, potentially higher than the value of your vote. A TravelFeed curator is part of our team and controls smiles given by the account @travelfeed.',
    },
    {
      questionName:
        'Can I participate in TravelFeed from other Hive frontends?',
      acceptedAnswerText:
        'We recommend posting through TravelFeed, but your posts will also appear on TravelFeed if you post from other Hive frontends using a code snippet generated using our map picker. Please note that the #travelfeed tag was discontinued in 2020 and only using the tag will not result in your post being added to TravelFeed.',
    },
    {
      questionName: 'What is a Blockchain?',
      acceptedAnswerText:
        'A blockchain is a public, immutable, decentralized and censorship-resistant way of storing data secured by cryptography. There are social blockchains such as Hive that grow communities and make immediate revenue streams possible for users by rewarding them for sharing content.',
    },
    {
      questionName: 'Where does the money come from?',
      acceptedAnswerText:
        'HIVE is an inflationary currency with a yearly inflation rate of under 10%. A large part of the tokens generated by inflation goes towards the rewards pool that is distributed among content creators and curators through giving upvotes (smiles).',
    },
    {
      questionName: 'Does TravelFeed charge beneficiary rewards?',
      acceptedAnswerText:
        'When posting to Hive, there is no default beneficiary fee, but you can customize beneficiaries.',
    },
    {
      questionName: 'Is there a mobile app for TravelFeed?',
      acceptedAnswerText:
        "Yes, the TravelFeed App is available for both Android and iOS. It lets you discover new places, start your travel blog, and connect with travelers worldwide — essentially an optimized version of our web platform for mobile devices. You can <a href='https://travelfeed.com/app'>find more information and download links here</a>.",
    },
    {
      questionName:
        'What is the TravelFeed Help Center and how can I access it?',
      acceptedAnswerText:
        'The TravelFeed Help Center is your go-to resource for guides on using our platform, from setting up your travel blog to getting the most out of the editor. You can access it from anywhere on TravelFeed by pressing ⌘K on Mac or Ctrl+K on Windows, or by clicking the Help Center link in the dashboard navigation menu.',
    },
    {
      questionName:
        'How can I connect with other travel bloggers on TravelFeed?',
      acceptedAnswerText:
        'You can connect with other travel bloggers by engaging with their content through comments and upvotes, following their accounts, and participating in TravelFeed community contests. We also encourage you to <a href="https://discord.gg/jWWu73H" target="_blank" rel="nofollow noreferrer noopener">join our Discord server</a> for real-time interactions with fellow travelers and bloggers.',
    },
  ];
  return (
    <>
      <FAQPageJsonLd mainEntity={faqs} />
      <div>
        {faqs.map(item => {
          return (
            <FaqItem
              key={item.questionName}
              title={item.questionName}
              content={item.acceptedAnswerText}
            />
          );
        })}
      </div>
    </>
  );
};

export default FAQAccordion;
